/**
 * Full Bleed Banner. Laying the groundwork for custom cover and contain functionality.
 */
(function ($) {
	const fullBleedBanner = ".wp-block-cd-full-bleed-banner";
	const bannerImg = "> img";
	const loadedClass = "is-loaded";
	let $fullBleedBanner = $(fullBleedBanner);

	function scaleBanners( $container ) {
		let $image = $container.find(bannerImg);
		if ($container.hasClass("contain")) {
			scaleImageContainer($container, $image, true);
		} else {
			scaleImageContainer($container, $image);
		}
		$container.addClass(loadedClass);
	}

	function parallaxBanners( $container ) {
		let $image = $container.find(bannerImg);
		if( !$container.hasClass("is-parallax") ) return;
		let containerView = elementInView( $container );
		if (containerView === "view") {
			parallaxImageContainer($container, $image);
		}
	}

	$(document).ready(function() {
		// Little time to make sure things are initialized
		$fullBleedBanner.each(function () {
			let $container  = $(this);
			let $image      = $(this).find(bannerImg);
			
			const thisInterval = setInterval(() => {	
				const naturalWidth      = $image.get(0).naturalWidth;
				const naturalHeight     = $image.get(0).naturalHeight;
				
				if( naturalHeight > 0 && naturalWidth > 0 ) {
					clearInterval( thisInterval );
					scaleBanners( $container );
					parallaxBanners( $container );
				}
			}, 100);
		});
	});

	$(window).on("resize", function () {
		$fullBleedBanner.each(function () {
			scaleBanners( $(this) );
		});
	});

	$(window).on("scroll", function () {
		$fullBleedBanner.each(function () {
			parallaxBanners( $(this) );
		});
	});
})(jQuery);
